import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import map from 'lodash/map';
import truncate from 'lodash/truncate';
import { v4 } from 'node-uuid';
import classnames from 'classnames';
import moment from 'moment';
import Avatar from 'common/components/avatar';

const Permission = ({ name, enabled, toggle }) => (
  <span className="checkbox">
    <input onChange={toggle} type="checkbox" id={name} checked={enabled} className="form-control" />
    <label htmlFor={name} className="form-label">{name}</label>
  </span>
);

const Row = ({
  active, toggle, resend, projectId, collaborator, permissions,
  updatePermission, startDelete, fetchHistory,
}) => {
  const { id, user, accepted, last_sent_at } = collaborator;
  const onResend = partial(resend, projectId, id);
  const onToggle = partial(toggle, id);
  const onTrash = partial(startDelete, { id, user });
  const close = partial(toggle, null);
  const userClick = partial(fetchHistory, projectId, id, user);
  const classes = classnames({ active: active === id });
  const nowMoment = moment();
  const lastMoment = moment(last_sent_at);
  const duration = moment.duration(nowMoment.diff(lastMoment));
  const hours = duration.asHours();

  /* @TODO:
    This inserts mutliple <tbody> tags into a table, which isn't ideal
  */
  return (<tbody className={classes}>
    <tr>
      <td className="user-column">
        <Avatar user={{avatar: user.avatar }} onClick={userClick}
          extraClasses="avatar avatar-sm avatar-inline show-for-medium pull-left" />
        <button className="btn btn-md btn-text" onClick={userClick}>
          <span className="hide-for-small-only">{user.username}</span>
          <span className="show-for-small-only">{truncate(user.username, { length: 15 })}</span>
        </button>
      </td>
      <td className="status-column">{accepted ? 'accepted' : 'pending'}</td>
      <td className="actions">
        {!accepted && hours > 4 &&
        <button className="btn btn-text btn-md show-for-large" onClick={onResend}>
          Resend Invite
        </button>}
        <button className="btn btn-text btn-md" onClick={active !== id? onToggle : close}>
          Permissions
        </button>
        <button className="btn btn-icon-only btn-delete" onClick={onTrash}><i className="fa fa-trash"/></button>
      </td>
    </tr>
    {active === id && <tr>
      <td colSpan={3}>
        {map(permissions, (permission) => {
          const [key, text] = permission;
          const enabled = collaborator.permissions[key];
          const newPerm = {};
          newPerm[key] = !enabled;
          const togglePermission = partial(updatePermission, projectId, id, newPerm);
          return (<Permission
            enabled={enabled}
            key={v4()}
            toggle={togglePermission}
            name={text}
          />);
        })}
      </td>
    </tr>}
  </tbody>);
};

Permission.propTypes = {
  toggle: PropTypes.func.isRequired,
  enabled: PropTypes.bool,
  name: PropTypes.string,
};

Row.propTypes = {
  projectId: PropTypes.number.isRequired,
  active: PropTypes.number,
  toggle: PropTypes.func.isRequired,
  resend: PropTypes.func.isRequired,
  startDelete: PropTypes.func.isRequired,
  fetchHistory: PropTypes.func.isRequired,
  updatePermission: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
  collaborator: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    accepted: PropTypes.bool,
  }),
};

export default Row;



// WEBPACK FOOTER //
// ./project/components/collaborator_row.jsx